<template>   
<div class="input-area">     
<el-input autoId="input_loginFrom_phone" class="input-item" v-model="loginFrom.phone" maxlength="11" placeholder="请输入手机号"> 
</el-input>     
<el-input autoId="input_loginFrom_password" v-if="loginType === 1" class="input-item" v-model="loginFrom.password" type="password"  :placeholder="placeholderInfo"> 
</el-input>     
<div v-if="loginType === 0">       <drag-verify         class="drag"         ref="dragVerify"         :isPassing.sync="isPassing"         :width="285"         completedBg="#79C23D"         text="验证码"         successText="验证通过"         handlerIcon="el-icon-arrow-right"         successIcon="el-icon-check"         @passcallback="success"       >       </drag-verify>     
</div>     
<div v-if="loginType === 0 && showTimeDown" class="input-item code-input">       
<el-input autoId="input_loginFrom_code" v-model="loginFrom.code" maxlength="11" placeholder="验证码"> 
</el-input>       <span v-show="timeDown === 60" @click="timing">{{ timeDesc }}</span>       <span v-show="timeDown !== 60" class="code-disabled">倒计时 {{ timeDown }} s</span>     
</div>     <!-- 
<el-input autoId="input_loginFrom_pwd" class="input-item" v-model="loginFrom.pwd"> 
</el-input> -->     
<el-button autoId="btn_submit" class="submit" type="primary" @click="submit">登录 
</el-button>     
<el-button autoId="btn_forgetPwd" v-if="loginType === 1" class="forget" type="text" @click="forgetPwd">忘记密码 
</el-button>     <img class="wechart" src="@/assets/images/temp/wechart.svg" alt="微信" />   
</div> </template>

<script>
import dragVerify from 'vue-drag-verify2'
import { loginCode, smsLogin } from '@/api/login'
import { Message } from 'element-ui'
import { checkPhoneFormat } from '@/utils/ruoyi'
export default {
  components: {
    dragVerify
  },
  props: {
    loginType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isPassing: false,
      showTimeDown: false,
      value1: 8,
      timer: null,
      timeDesc: '发送验证码',
      placeholderInfo: '请输入密码',
      timeDown: 60,
      loginFrom: {
        phone: '',
        password: '',
        code: ''
      }
    }
  },
  methods: {
    cleaerInfo() {
      this.isPassing = false
      this.loginFrom.phone = ''
      this.loginFrom.password = ''
      this.loginFrom.code = ''
    },
    submit() {
      if (this.checkValidate()) {
        this.loginType === 0 ? this.submitCode() : this.submitPwd()
      }
    },
    checkValidate() {
      const form = this.loginFrom
      if ((!form.password && this.loginType === 1) || (!form.code && this.loginType === 0) || !form.phone) {
        Message({ message: '请将信息填写完整', type: 'error' })
        return false
      }
      if (!checkPhoneFormat(form.phone)) {
        Message({ message: '手机号格式不正确', type: 'error' })
        return false
      }
      return true
    },
    submitPwd() {
      const params = {
        phonenumber: this.loginFrom.phone,
        password: this.$aesEncrypt.encrypt(this.loginFrom.password)
      }
      this.$store.dispatch('passwordLogin', params).then(() => {
        this.$store.dispatch('GetInfo')
        this.$emit('success')
        this.$store.dispatch('getUnreadMessageCount')
      })
    },
    submitCode() {
      const params = {
        phoneNumber: this.loginFrom.phone,
        code: this.loginFrom.code
      }
      this.$store
        .dispatch('smsLogin', params)
        .then(() => {
          this.$store.dispatch('GetInfo').then((res) => {
            this.$emit('success', res.member)
            this.$store.dispatch('getUnreadMessageCount')
          })
        })
        .catch(() => {
          this.loading = false
          if (this.captchaEnabled) {
            this.getCode()
          }
        })
    },
    success() {
      this.showTimeDown = true
    },
    forgetPwd() {
      this.$emit('switch', 'forget')
    },
    timing() {
      if (!checkPhoneFormat(this.loginFrom.phone)) {
        Message({ message: '手机号格式不正确', type: 'error' })
        return false
      }
      if (this.timeDown === 60 && !this.timer) {
        this.timeDown -= 1
        this.timer = setInterval(() => {
          this.timeDown -= 1
          if (this.timeDown === 0) {
            clearInterval(this.timer)
            this.timer = null
            this.timeDown = 60
            this.timeDesc = '发送验证码'
          }
        }, 1000)
        loginCode(this.loginFrom.phone).then((res) => {})
      }
      return
    }
  }
}
</script>
<style lang="scss" scoped>
.input-area {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.input-item {
  height: 40px;
  overflow: hidden;
  margin-bottom: 8px;
  border: 1px solid #dedede;
  border-radius: 0;
  ::v-deep input {
    border: none;
  }
}
.code-input {
  display: flex;
  .el-input {
    width: 70%;
  }
  span {
    flex: 1;
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color);
  }
  .code-disabled {
    color: #999999;
  }
}
.submit {
  background: var(--color) !important;
  border: none;
  border-radius: 0;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  &:hover,
  &:active {
    background: rgba(18, 161, 130, 0.68);
  }
}

.wechart {
  display: none;
  cursor: pointer;
  width: 38px;
  height: 38px;
  margin: auto;
  margin-top: 18px;
}
.drag {
  margin-bottom: 8px;
  border: 1px solid #dedede;
  height: 40px;
  line-height: 40px;
  border-radius: 0 !important;
  ::v-deep > div {
    border-radius: 0 !important;
  }
}
.forget {
  align-self: flex-end;
  width: 60px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  padding-bottom: 0;
}
</style>
